/** @format */

import { BASE_URL, XAMPLIFIER_BASE_URL } from "../config";

export const API_ROUTES = {
  GET_PAITENTDETAILS: `${BASE_URL}contactListFilters`,
  GET_LIST: `${BASE_URL}getListName`,
  GET_USER_DETAILS: `${XAMPLIFIER_BASE_URL}user`,
  GET_HISTORY_LIST_DOCS: `${BASE_URL}getListDocs`,
  GET_SMSCAMPAIGN: `${BASE_URL}getSMSCampaign`,
  GET_CAMPAIGNSTATUS: `${BASE_URL}getCampaignStatus`,
  GET_CAMPAIGNLIST: `${BASE_URL}getList`,
  GET_CONTACT_LIST: `${BASE_URL}getContactList`,
  GET_DROPDOWN_DATA: `${BASE_URL}getContactDropDownData`,
  GET_CHART_DATA: `${BASE_URL}contactDashboard`,
  // GET_CLIENTBRAND: `${Base_Url}getClientBrands`,
  GET_CLIENTBRAND: `${XAMPLIFIER_BASE_URL}clients`,
  GET_SWITCH_CLIENTS: `${XAMPLIFIER_BASE_URL}switch/clients`,

  POST_EXPORT_FILE: `${BASE_URL}exportFile`,
  POST_CREATECAMPAIGN: `${BASE_URL}createSMSCampaign`,
  POST_FILTERDOCS: `${BASE_URL}filterDocs`,
  POST_REFRESH: `${BASE_URL}refreshList`,
  POST_RESCHEDULECANCEL: `${BASE_URL}smsRescheduleCancel`,
  POST_ADDCONTACT: `${BASE_URL}addContact`,
  POST_LOGIN: `${XAMPLIFIER_BASE_URL}login`,
  POST_SMS_TEST_RUN: `${BASE_URL}smsTestRun`,
  POST_ADMIN_LOGIN: `${BASE_URL}adminLogin`,
  GET_CLIENT_LINKS: `${BASE_URL}getClientLinks`,
  GET_TEST_SMS_CONTACTS: `${BASE_URL}getTestSMSContacts`,
};
